import styled from "@emotion/styled"
import { Value } from "@stringtale/react"
import { useCurrentUser } from "app/core/hooks/useCurrentUser"
import { useIsKids } from "app/core/hooks/useIsKids"
import { useIsPublic } from "app/core/hooks/useIsPublic"
import DashboardLayout from "app/core/layouts/DashboardLayout"
import Layout from "app/core/layouts/Layout"
import PublicLayout from "app/core/layouts/PublicLayout"
import { UserInfoProvider } from "app/core/providers/UserInfoProvider"
import { useRouter } from "app/core/hooks/useRouter"
import { useEffect } from "react"
import { LIGHT_GREEN_COLOR } from "theme/consts"
import RoundedButton from "ui/RoundedButton"
import { ErrorContainer } from "./components/ErrorContainer"

const Body = styled.div`
  background-color: ${LIGHT_GREEN_COLOR};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const ContentNotAvailableContent = function () {
  const router = useRouter()
  const isPublic = useIsPublic()
  const user = useCurrentUser()
  const isKids = useIsKids()

  useEffect(() => {
    if (!isPublic && !user && !isKids) {
      router.push(`/login`)
    }
  }, [isPublic, user, router, isKids])

  if (isKids) {
    return (
      <Layout title="Pagina niet gevonden">
        <Body>
          <ErrorContainer
            title={
              <Value name="apps.web.src.errors.contentnotavailable.geen_toegang_tot_deze_les_kids">
                Geen toegang tot deze les
              </Value>
            }
            message={
              <Value name="apps.web.src.errors.contentnotavailable.deze_les_is_niet_langer_publiek_beschikbaar_kids">
                Deze les is niet langer beschikbaar. Ga terug naar de Kidspagina
                en probeer een andere les.
              </Value>
            }
            button={
              <RoundedButton
                variant="filled"
                type="button"
                onClick={() => {
                  window.location.href = "https://kids.123zing.nl"
                }}
              >
                <Value name="apps.web.src.errors.contentnotavailable.ga_naar_de_kidspagina">
                  Ga naar de Kidspagina
                </Value>
              </RoundedButton>
            }
          />
        </Body>
      </Layout>
    )
  }

  if (isPublic) {
    return (
      <PublicLayout
        title="Content niet beschikbaar"
        forceShowTrialButton={true}
      >
        <Body>
          <ErrorContainer
            title={
              <Value name="apps.web.src.errors.contentnotavailable.geen_toegang_tot_deze_les">
                Geen toegang tot deze les
              </Value>
            }
            message={
              <Value name="apps.web.src.errors.contentnotavailable.deze_les_is_niet_langer_publiek_beschikbaar">
                Deze les is niet langer publiek beschikbaar.
              </Value>
            }
            button={
              <RoundedButton
                variant="filled"
                type="button"
                onClick={() => {
                  window.location.href = "https://www.123zing.nl"
                }}
              >
                <Value name="apps.web.src.errors.contentnotavailable.button_123zing">
                  Ga naar www.123zing.nl
                </Value>
              </RoundedButton>
            }
          />
        </Body>
      </PublicLayout>
    )
  }

  if (!user) {
    return null
  }

  return (
    <DashboardLayout
      title="Geen toegang tot dit lesmateriaal"
      disablePadding={true}
    >
      <Body>
        <ErrorContainer
          title={
            <Value name="apps.web.src.errors.contentnotavailable.title">
              Geen toegang tot dit lesmateriaal
            </Value>
          }
          message={
            <Value name="apps.web.src.errors.contentnotavailable.message">
              Dit lesmateriaal is niet beschikbaar binnen jouw abonnement.
            </Value>
          }
          button={
            <RoundedButton
              variant="filled"
              type="button"
              onClick={async () => {
                router.push("/")
              }}
            >
              <Value name="apps.web.src.errors.contentnotavailable.button">
                Terug naar home
              </Value>
            </RoundedButton>
          }
        />
      </Body>
    </DashboardLayout>
  )
}

export const ContentNotAvailable = function () {
  return (
    <UserInfoProvider>
      <ContentNotAvailableContent />
    </UserInfoProvider>
  )
}
